export default "__VITE_ASSET__DWZuaxOk__"